import React from 'react';
import styled from 'styled-components';
import { primaryColor, errorColor } from '~theme';
import checkedIcon from '~images/radio_active.svg';
import uncheckedIcon from '~images/radio_inactive.svg';

const RadioButton = props => (
  <Wrapper onClick={props.onClick}>
    <Icon src={props.checked ? checkedIcon : uncheckedIcon} />
    <Label errored={props.errored}>{props.label}</Label>
  </Wrapper>
);

const Icon = styled.img`
  width: 22px;
  height: 22px;
  margin-right: 12px;
  color: ${primaryColor};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Label = styled.span`
  color: ${props => (props.errored ? errorColor : 'black')};
`;

export default RadioButton;
